import { Box, Link } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import TkButton from "../../components/atoms/TkButton";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkDataTable from "../../components/molecules/TkDataTable";
import { headList, listData, schema } from "./parts";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { httpAPI_MAI002 } from "./api/request";
import { TkGetCode } from "../../utils/TkGetCode";
import { EmailClass } from "../../assets/data/Constants";
import dayjs from "dayjs";
import _ from "lodash";

/**
 * SCRW130002 送信メール
 * @return SCRW130002 送信メール
 */
const SCRW130002 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_122;
  const [SCRW130002Data, setSCRW130002Data] = useState<any>();
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(listData));
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const startErr = !!startDate && isNaN(new Date(startDate)?.getTime?.());
  const endErr = !!endDate && isNaN(new Date(endDate)?.getTime?.());

  useEffect(() => {
    let resArr = searchList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;

      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);
    if (context) {
      handleGetNewBodyList({ ...context });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickTitle = (selectedEmailId: any, selectedSendEmail: any) => {
    navigate("/SCRW130003", {
      state: { emailId: selectedEmailId, emailAddress: selectedSendEmail },
    });
  };

  const handleTemplateList = () => {
    navigate("/SCRW140001");
  };
  const createNewEmail = () => {
    navigate("/SCRW130003");
  };
  const handleStartDate = (date: any) => {
    setStartDate(date.target.value);
  };
  const handleEndDate = (date: any) => {
    setEndDate(date.target.value);
  };

  const handleGetNewBodyList = async (data: any) => {
    if (startErr || endErr) return;
    // 相関チェック
    if (new Date(startDate) > new Date(endDate)) {
      setState({ ...state, errorMsgId: "TKMSG_SCR0095E" });
      return;
    }
    // メール一覧参照API 呼び出し
    try {
      const param = {
        sendDatetimeFrom: data.sendDateTimeFrom ?? startDate,
        sendDatetimeTo: data.sendDatetimeTo ?? endDate,
        ...data,
      };
      const res = await httpAPI_MAI002({ ...param });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setSCRW130002Data(res.emailList);

        setBusinessState({
          job_122: { ...param },
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
        setBodyList([]);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (!SCRW130002Data) return;
    setBodyList(
      SCRW130002Data.map((item: any) => {
        return [
          {
            children: TkGetCode(EmailClass, item.emailClass),
            forSort: item.emailClass,
          },
          {
            children: (
              <Link
                onClick={() => handleClickTitle(item.emailId, item.sendEmail)}
              >
                {item.title}
              </Link>
            ),
            forSort: item.title,
          },
          {
            children:
              !item.corpName || item.corpName === ""
                ? item.sendEmail
                : (item.contractorNo ?? "") + ":" + (item.corpName ?? ""),
            forSort: item.contractorNo,
          },
          {
            children: dayjs(item.requestDatetime).format("YYYY/MM/DD HH:mm"),
            forSort: item.requestDatetime,
          },
          { children: item.sendDatetime, forSort: item.sendDatetime },
          { children: item.sendFlg, forSort: item.sendFlg },
        ];
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SCRW130002Data]);

  return (
    <Box className="SCRW130002" data-testid="SCRW130002PageForTest">
      <Box className="head">
        <Box className="left">
          <Box>送信期間：</Box>
          <TkDatePicker
            onChange={handleStartDate}
            minDate={new Date("1900-01-01")}
            maxDate={new Date()}
            wantToSetValue={context?.sendDatetimeFrom}
          />
          <Box>～</Box>
          <TkDatePicker
            onChange={handleEndDate}
            minDate={new Date("1900-01-01")}
            maxDate={new Date()}
            wantToSetValue={context?.sendDatetimeTo}
          />
        </Box>
        <Box className="right">
          <TkButton onClick={handleTemplateList}>テンプレート一覧</TkButton>
          <TkButton onClick={createNewEmail}>メール新規作成</TkButton>
        </Box>
      </Box>
      <Box className="mid">
        <TkSearchForm
          onSearch={handleGetNewBodyList}
          listData={stateSearchList}
          ruleSchema={schema}
        />
      </Box>
      <Box className="form">
        <TkDataTable headList={headList} bodyList={bodyList} pagin={true} />
      </Box>
    </Box>
  );
};

export default SCRW130002;
